var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ActionStatus, securityApi } from "apis/eduidSecurity";
import { useAppDispatch } from "eduid-hooks";
import { useCallback } from "react";
import authnSlice from "slices/Authn";
export function useReAuthenticate() {
    const dispatch = useAppDispatch();
    const [getAuthnStatus] = securityApi.useLazyGetAuthnStatusQuery();
    const checkAuthnStatus = useCallback((frontend_action, frontend_state) => __awaiter(this, void 0, void 0, function* () {
        dispatch(authnSlice.actions.setFrontendActionAndState({
            frontend_action,
            frontend_state,
        }));
        const response = yield getAuthnStatus({ frontend_action });
        if (response.isSuccess && response.data.payload.authn_status === ActionStatus.OK) {
            return true;
        }
        dispatch(authnSlice.actions.setReAuthenticate(true));
        return false;
    }), [dispatch, getAuthnStatus]);
    const resetAuthn = useCallback(() => {
        dispatch(authnSlice.actions.setAuthnFrontendReset());
    }, [dispatch]);
    return { checkAuthnStatus, resetAuthn };
}
